import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export const MIN_SEARCH_LENGTH = 3;

type SearchProps = {
  search: string;
  setSearch: (value: string) => void;
  placeholder?: string;
};

function Search({ search, setSearch, placeholder = 'جستجوی آزمون...' }: SearchProps) {
  return (
    <div
      className='
        relative mx-auto flex w-full max-w-md rounded-2xl border border-zinc-200
        bg-white/80 px-2 py-1 pr-5 shadow-sm focus:border-amber-400
        focus:ring-4 focus:ring-amber-100
      '
    >
      <MagnifyingGlassIcon width={20} />
      <input
        type='text'
        placeholder={placeholder}
        value={search}
        onChange={e => setSearch(e.target.value)}
        className='
          w-full px-2 py-1 pr-5 text-sm outline-none transition-all
          duration-200 placeholder:text-zinc-400
        '
      />
    </div>
  );
}

export default Search;
